import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => ({
  monthLevel: {},
  calendarHeader: {
    marginBottom: theme.spacing.xs
  }
}));

export default useStyles;
//# sourceMappingURL=MonthLevel.styles.js.map
